import { gettext } from '@eventbrite/i18n';
import React, { Component } from 'react';
import './LandingPhoto.scss';

export interface LandingPhotoStructure {
    location: string;
}
class LandingPhoto extends Component<LandingPhotoStructure> {
    render() {
        const { location } = this.props;

        if (location != 'san-francisco') {
            return '';
        }

        return (
            <section
                className="landing-photos__section"
                data-location="san-francisco"
            >
                <div className="landing-photos__container eds-g-cell eds-g-cell-10-12 eds-g-cell-lg-12-12 eds-g-cell--no-gutters">
                    <div className="eds-g-cell eds-g-cell-12-12 eds-l-pad-vert-4 eds-l-sm-pad-vert-3 eds-l-mar-top-5">
                        <h4 className="eds-text-hm eds-text-weight--light">
                            {gettext('San Francisco')}
                        </h4>
                        <p className="eds-text-bm eds-text-weight--light eds-l-mar-top-2">
                            {gettext(
                                "Briteland HQ is rooted in the heart of SOMA, steps from all major public transportation and equipped with tons of bike parking. The floor-to-ceiling windows of some of the best views the city has to offer right from the comfort of your desk. Face off with Britelings in our arcade, or challenge us to a game of ping-pong. Oh, did we mention we're dog-friendly?",
                            )}
                        </p>
                    </div>
                    <div className="landing-photos__grid eds-l-pad-bot-3">
                        <div className="landing-photos__photo landing-photos__photo--one">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/899a2a/django/images/pages/about/grid-design-lab.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--two">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/be567b/django/images/pages/about/grid-bike-hillary.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--three">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/c6f446/django/images/pages/about/grid-james.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--four">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/8ba2c9/django/images/pages/about/grid-wine.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--five">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/ba14c5/django/images/pages/about/grid-bleachers.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--six">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/c826f7/django/images/pages/about/grid-hammock-mike.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--seven">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/252a79/django/images/pages/about/grid-pingpong-sarah.jpg"
                                className="eds-max-img"
                            />
                        </div>
                        <div className="landing-photos__photo landing-photos__photo--eight">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/baf792/django/images/pages/about/grid-rooftop.jpg"
                                className="eds-max-img"
                            />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default LandingPhoto;
